export const SOCKET_EVENTS = {
  REGISTER_CLIENT: 'register-client',
  NOTIFICATION: 'notification'
}
